"use client";
import Image from "next/image";
import React from "react";
import Link from "next/link";

const AboutUS = () => {
  const [showLogo, setShowLogo] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLogo(true);
    }, 300);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <section id="about" className="mx-4 mt-10 md:mx-10 md:mt-20 lg:mt-2">
      <div className="text-center">
        <h2 className="text-4xl font-semibold leading-tight text-black dark:text-white sm:text-5xl md:text-6xl lg:text-5xl">
          Spanda is designed, developed and brought to you by{" "}
          {/* <span
            className={`${
              showLogo ? "opacity-100" : "opacity-0"
            } font-serif font-medium text-saintiantblue transition-opacity duration-300 sm:text-6xl`}
          >
            Saintiant Technologies Pvt Ltd.
          </span> */}
        </h2>
        <hr className="my-5 border-t border-gray-300 dark:border-gray-700" />
      </div>

      <div
        className={`mt-16 flex justify-center ${
          showLogo ? "fade-in" : "hidden"
        }`}
      >
        {showLogo && (
          <div className="text-center">
            {/* <Image
              src="/images/logo/saintiant.png"
              width={500}
              height={500}
              alt="Saintiant Technologies Logo"
              className={`opacity-100 transition-opacity`}
            /> */}
            <Image
              src="/images/blog/saintlogo.png"
              width={500}
              height={500}
              alt="Saintiant Technologies Logo"
              className={`opacity-100 transition-opacity`}
            />
          </div>
        )}
      </div>

      <h2
        className={`mt-10 text-center text-lg font-semibold leading-tight text-black dark:text-white sm:text-2xl md:text-2xl lg:text-2xl xl:text-3xl ${
          showLogo ? "fade-in" : "opacity-0"
        } transition-opacity`}
      >
        A new age company
      </h2>
      <h2
        className={` text-center text-lg font-medium leading-tight text-black dark:text-white sm:text-2xl md:text-2xl lg:text-2xl xl:text-3xl ${
          showLogo ? "fade-in" : "opacity-0"
        } transition-opacity`}
      >
        with a team of technocrats and medical professionals
      </h2>
      <h2
        className={` text-center text-lg font-medium leading-tight text-black dark:text-white sm:text-2xl md:text-2xl lg:text-2xl xl:text-3xl ${
          showLogo ? "fade-in" : "opacity-0"
        } transition-opacity`}
      >
        working closely to redefine healthcare.
      </h2>
      {/* <h2
        className={`mt-4 text-center text-lg font-medium leading-tight text-black dark:text-white sm:text-2xl md:text-2xl lg:text-xl xl:text-3xl ${
          showLogo ? "fade-in" : "opacity-0"
        } transition-opacity`}
      >
        We harness cutting-edge technologies into innovative products to promote
        healthier outcomes and save lives.
      </h2> */}
      <div
        className={`relative z-10 mt-5 overflow-hidden rounded-md bg-primary bg-opacity-10 p-8 md:p-9 lg:p-8 xl:p-9 ${
          showLogo ? "fade-in" : "opacity-0"
        } transition-opacity`}
      >
        <p className="text-center text-xl font-medium italic text-body-color">
          Promoting healthier outcomes and saving lives is our mission.
        </p>
      </div>
      <div
        className={`flex flex-col items-center justify-center space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0 ${
          showLogo ? "fade-in" : "opacity-0"
        } transition-opacity`}
      >
        <Link
          href="https://www.saintiant.tech/About"
          className=" mt-5 inline-block rounded-full bg-saintiantblue px-6 py-3 text-base font-semibold text-white duration-300 ease-in-out hover:bg-black/90 dark:bg-white/10 dark:text-white dark:hover:bg-white/5 sm:px-8 sm:py-4 sm:text-lg"
        >
          Know More
        </Link>
      </div>

      <style jsx>{`
        .fade-in {
          opacity: 1;
          transition: opacity 1s ease-in-out;
        }
        .opacity-0 {
          opacity: 0;
        }
      `}</style>
    </section>
  );
};

export default AboutUS;
